import { render, staticRenderFns } from "./WechatEditor.vue?vue&type=template&id=801c92d4"
import script from "./WechatEditor.vue?vue&type=script&lang=js"
export * from "./WechatEditor.vue?vue&type=script&lang=js"
import style0 from "./WechatEditor.vue?vue&type=style&index=0&id=801c92d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports